import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import AbaTypeEnum from '~Api/WarehouseLoanTransactionAba/AbaTypeEnum';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import { keyMap } from '~utilities/utils';
import { warehouseLoanTransactionSelector } from '~Warehouses/selectors';
import IWarehouseLoanTransactionAba from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAba';
import IWarehouseLoanTransactionAbaHistory from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAbaHistory';

export function abasSelector(state: IGlobalState): IDictionary<IWarehouseLoanTransactionAba> {
    return state.warehouseLoanTransactionAbas.abasListed && state.warehouseLoanTransactionAbas.abas;
}

export function abaHistoriesSelector(state: IGlobalState, warehouseLoanTransactionAbaUuid: string): IWarehouseLoanTransactionAbaHistory[] {
    return state.warehouseLoanTransactionAbas.abaHistories[warehouseLoanTransactionAbaUuid];
}

export function abaSelector(state: IGlobalState, uuid: string): IWarehouseLoanTransactionAba {
    return state.warehouseLoanTransactionAbas.abas && state.warehouseLoanTransactionAbas.abas[uuid];
}

export function abaTransactionsSelector(state: IGlobalState, warehouseLoanTransactionAbaUuid: string): IDictionary<IWarehouseLoanTransaction> {
    if (!state.warehouseLoanTransactionAbas.abaTransactionUuids[warehouseLoanTransactionAbaUuid]) {
        return null;
    }

    return keyMap(state.warehouseLoanTransactionAbas.abaTransactionUuids[warehouseLoanTransactionAbaUuid], 'uuid', (uuid: string) => warehouseLoanTransactionSelector(state, uuid));
}

export function unallocatedTransactionsSelector(state: IGlobalState, abaType: AbaTypeEnum): IDictionary<IWarehouseLoanTransaction> {
    if (!state.warehouseLoanTransactionAbas.unallocatedTransactionUuids[abaType]) {
        return null;
    }

    return keyMap(state.warehouseLoanTransactionAbas.unallocatedTransactionUuids[abaType], 'uuid', (uuid: string) => warehouseLoanTransactionSelector(state, uuid));
}
